import { Add, Cancel } from "@mui/icons-material";
import { Box, Button, Dialog, IconButton, Typography } from "@mui/material";
import AddNewCardForm from "components/add-new-card";
import Cards from "components/payment/cards";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchCart } from "slices/cartReducer";
import { useAppDispatch } from "store/appHooks";
import useQuery from "utils/router.util";

const SavedCardPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [addCard, setAddCard] = useState(false);
  const query = useQuery();

  useEffect(() => {
    dispatch(fetchCart({ query: "" }));
  }, []);

  return (
    <Box>
      <Box
        sx={{
          borderBottom: "1px solid #E2E2E2",
          py: "25px",
          px: { md: "80px", lg: "80px", xl: "80px", sm: "25px", xs: "25px" },
          display: "flex",
          alignItems: "center",
          gap: "15px",
        }}
        component="a"
        onClick={() => navigate(-1)}
      >
        <img src="/assets/img/icons/arrow_left.svg" alt="" />
        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 600,
            color: "#323232",
            lineHeight: "31px",
          }}
        >
          Saved Cards
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "20px",
          flexWrap: { sm: "wrap", xs: "wrap" },
        }}
      >
        <Box
          sx={{
            minWidth: {
              md: "25%",
              lg: "25%",
              xl: "25%",
              sm: "100%",
              xs: "100%",
            },
          }}
        >
          <Cards allowManage={true} />
        </Box>
        <Box
          sx={{
            flex: 1,
            display: {
              md: "block",
              lg: "block",
              xl: "block",
              sm: "none",
              xs: "none",
            },
          }}
        >
          <Box
            sx={{
              mx: {
                md: "30px",
                lg: "30px",
                xl: "30px",
                sm: "15px",
                xs: "15px",
              },
              mb: "20px",
            }}
          >
            <AddNewCardForm />
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: {
              md: "none",
              lg: "none",
              xl: "none",
              sm: "block",
              xs: "block",
            },
            px: "3%",
            py: "25px",
          }}
        >
          <Button
            startIcon={<Add />}
            sx={{
              padding: 0,
              flex: 1,
              height: "54px",
              borderRadius: "10px",
            }}
            variant="contained"
            fullWidth
            onClick={() => setAddCard(true)}
          >
            Add New Card
          </Button>
        </Box>
      </Box>

      {(addCard || query.get("id")) && (
        <Dialog open sx={{ m: 0, padding: "0 0 25px 0", height: "100%" }}>
          <Box sx={{ position: "absolute", right: 0 }}>
            <IconButton
              onClick={() =>
                query.get("id") ? navigate("/saved-cards") : setAddCard(false)
              }
            >
              <Cancel />
            </IconButton>
          </Box>
          <AddNewCardForm onSuccess={() => setAddCard(false)} />
        </Dialog>
      )}
    </Box>
  );
};

export default SavedCardPage;
